<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.agendamentoRetroativo"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(nome)="{item}">
            {{ item.nome }}

            <template v-if="item.nomeSocial">
                <template v-if="item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                    <strong>({{item.nomeSocial}})</strong>
                </template>

                <template v-else>
                    ({{item.nomeSocial}})
                </template>
            </template>
        </template>

        <template v-slot:cell(actions)="{item}">
            <rkm-button
                @click="create(item)"
                authorize="create-ambulatorio-agendamento-retroativo"
                color="primary"
                small
                title="Visualizar"
            >
                <rkm-icon icon="search" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Mixins.
import {repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            agendamentoRetroativo: this.getConectaSusRepository('ambulatorio.agendamentoRetroativo'),
        }
    },
    data: () => ({
        enums: {
            classificacao,
            preferenciaNome,
        },
        fields: [
            {key: 'nome', label: 'Nome (Nome social)', name: 'cidadao.nome', searchable: true, sortable: true},
            {key: 'nomeSocial', label: 'Nome social', name: 'cidadao.nomeSocial', searchable: true, sortable: true, visible: false},
            {key: 'dataNascimento', label: 'Data de nascimento', name: 'cidadao.dataNascimento', searchable: true, sortable: true},
            {key: 'prontuario', label: 'Prontuário municipal', name: 'paciente.prontuario', searchable: true, sortable: true},
            {key: 'cpf', label: 'CPF', name: 'cidadao.cpf', searchable: true, sortable: true},
            {key: 'cns', label: 'CNS', name: 'cidadao.cns', searchable: true, sortable: true},
            {key: 'nomeMae', label: 'Nome da mãe', name: 'cidadao.nomeMae', searchable: true, sortable: true},
            {key: 'municipioUf', label: 'Município / Estado', name: 'municipioUf', searchable: true, sortable: true},
            {key: 'validadeFim', label: 'Validade do cadastro', name: 'validadeFim', searchable: true, sortable: true},
            {key: 'actions', label: 'Ações', name: 'actions', class: 'col-min'},
        ],
    }),
    methods: {
        create(item) {

            const id = item.id

            if (item.diasCadastroDesatualizado > 0) {

                const confirm = async () => {

                    this.$router.push({name: 'ambulatorio-agendamento-retroativo-create', params: {id}})

                    return false
                }

                const msg = `Paciente com cadastro desatualizado há <strong>${item.diasCadastroDesatualizado}</strong>
                    dia(s). Deseja continuar?`

                this.showConfirmation(msg, confirm)

                return false
            }

            this.$router.push({name: 'ambulatorio-agendamento-retroativo-create', params: {id}})
        },
    },
    mixins: [repository],
}
</script>